import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { isEmpty, isExist } from "cxa-utils";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const HDFLink = ({
  planYearId,
  uwFormCode,
  enrolmentKey,
  completedOn,
  isMobileResponsive = false,
}) => {
  if (isEmpty(uwFormCode)) {
    return null;
  }
  return isExist(planYearId) ? (
    <h5>
      <span>
        <Link
          to={`/${
            isMobileResponsive ? "gen-hdf" : "hdf"
          }/${uwFormCode}/${planYearId}/${enrolmentKey}`}
          target="_blank"
        >
          e-HDF
        </Link>
      </span>
      <FormattedMessage
        {...messages.benefitStatement.hdfSubmittedOn}
        values={{
          when: moment(completedOn).format(),
        }}
      />
    </h5>
  ) : (
    <h5>
      <span>
        <Link to={`/hdf/${uwFormCode}/${enrolmentKey}`} target="_blank">
          e-HDF
        </Link>
      </span>
      <FormattedMessage
        {...messages.benefitStatement.hdfSubmittedOn}
        values={{
          when: moment(completedOn).format(),
        }}
      />
    </h5>
  );
};

HDFLink.propTypes = {
  planYearId: PropTypes.string,
  uwFormCode: PropTypes.string,
  enrolmentKey: PropTypes.number,
  completedOn: PropTypes.string,
  isMobileResponsive: PropTypes.bool,
};

HDFLink.defaultProps = {
  planYearId: "",
  uwFormCode: "",
};

export default HDFLink;



// WEBPACK FOOTER //
// ./components/employee/benefits/HDFLink.js